import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { bindFormModule } from '../../shared/formBinding.js';
import { formModalSaved, isFormModalOpen } from '../../shared/formModal.js';
import { hideLoading, notifyError, notifySuccess, showLoading } from '../../shared/notify.js';

// Optional free-text fields. An empty one is sent as '' rather than dropped:
// dropping it would mean "leave unchanged" on a PATCH, so clearing the address
// or the website in the form would never reach the record.
const NULLABLE_TEXT = ['strasse', 'plz', 'ort', 'website', 'notiz'];

// Turns the form into the JSON body the API expects.
function readForm(form) {
  const data = Object.fromEntries(new FormData(form).entries());

  // An unchecked checkbox is not submitted at all, so the absent key is the
  // "false" the server needs to see - FormData cannot express it.
  data.aktiv = form.querySelector('#aktiv')?.checked ?? true;

  NULLABLE_TEXT.forEach((field) => {
    if (data[field] !== undefined) data[field] = data[field].trim();
  });

  return data;
}

async function submit(form) {
  const submitButton = form.querySelector('button[type="submit"]');
  const { konzernId } = form.dataset;
  const data = readForm(form);

  if (submitButton) submitButton.disabled = true;
  showLoading('Wird gespeichert …');

  try {
    if (konzernId) await http.patch(`/konzerne/${konzernId}`, data);
    else await http.post('/konzerne', data);

    // In the dialog the list is already on screen behind it, so closing and
    // refetching shows the result without a reload. On the standalone page there
    // is nothing to go back to, so it navigates and the flash key carries the
    // message across the load.
    if (isFormModalOpen()) {
      hideLoading();
      formModalSaved();
      notifySuccess(konzernId ? 'Konzern wurde aktualisiert.' : 'Konzern wurde erstellt.');
    } else {
      const key = konzernId ? 'konzern-aktualisiert' : 'konzern-erstellt';
      window.location.href = withFlash('/konzerne', key);
    }
  } catch (err) {
    hideLoading();
    if (submitButton) submitButton.disabled = false;
    // The 409 a duplicate name answers is worth showing verbatim: it says the
    // group already exists, which is what the reader has to act on.
    notifyError(
      err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
    );
  }
}

export function initKonzernForm() {
  bindFormModule('konzern-form', submit);
}
